import { render, staticRenderFns } from "./ModalMaterialsDelete.vue?vue&type=template&id=7133ca30&"
import script from "./ModalMaterialsDelete.vue?vue&type=script&lang=js&"
export * from "./ModalMaterialsDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalMaterialsDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports